import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withLegacyRouter } from '../../../../../decorators'
import { ResuscitationQuestionnaire } from '../../../../../lib/Questionnaires'
import { IGAO } from '../../../../igao'
import { CircularProgress } from '../../../../shared/NarusMaterial'
import { getAssessment } from '../../lib/new-actions'

import { getSupportingDocs } from './actions'
import AttorneyGrid from './Attorney/AttorneyGrid'
import ResuscitationChoiceForm, {
  RESUSCITATION_CATEGORY
} from './ResuscitationChoice/resuscitationChoiceForm'
import SupportingDocumentationGrid from './SupportingDocumentation/DocumentationsGrid'

class Choices extends React.Component {
  UNSAFE_componentWillMount () {
    this.props.getAssessment(
      this.props.patientId,
      RESUSCITATION_CATEGORY,
      ResuscitationQuestionnaire
    )
    this.props.getSupportingDocs(this.props.patientId)
  }

  renderBody () {
    const { params } = this.props
    return (
      <div>
        <SupportingDocumentationGrid params={params} />
        <AttorneyGrid params={{ id: params.id }} />
      </div>
    )
  }

  render () {
    const { questionnaire } = this.props
    const resFormData = _.get(
      questionnaire,
      `[${RESUSCITATION_CATEGORY}].formData`
    )
    const resLoading = _.get(
      questionnaire,
      `[${RESUSCITATION_CATEGORY}].loading`
    )
    return (
      <div className='main'>
        <h1>Resuscitation Choice</h1>
        {resLoading
          ? (
            <CircularProgress />
          )
          : (
            <ResuscitationChoiceForm
              initialValues={resFormData}
              patientId={this.props.params.id}
            />
          )}

        <h2>Supporting Documentation</h2>
        {this.renderBody()}
        <IGAO path='choices' />
      </div>
    )
  }
}

const mapStateToProps = redux => {
  const patientId = redux?.globalVars?.params?.id
  const { questionnaire } = redux
  return {
    questionnaire,
    patientId
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAssessment,
      getSupportingDocs
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(withLegacyRouter(Choices))
